import type { IconName } from '@/design-system/icons/Icon';

export type FeatureGroup = 'community' | 'discovery' | 'tools' | 'environment';

export type FeatureMeta = {
  id: FeatureId;
  label: string;
  icon: IconName;
  group: FeatureGroup;
  desc: string;
  surfaces: string[];
  defaultOff?: boolean;
  available?: boolean;
};

export type FeatureId =
  | 'feed'
  | 'communities'
  | 'messages'
  | 'notifications'
  | 'reels'
  | 'explore'
  | 'strains'
  | 'associations'
  | 'marketplace'
  | 'ia'
  | 'donations'
  | 'commercial_payments'
  | 'roleSwitcher'
  | 'maintenance';

export const FEATURES_REGISTRY: FeatureMeta[] = [
  { id: 'feed', label: 'Feed', icon: 'activity', group: 'community', desc: 'Linha do tempo da comunidade.', surfaces: ['Menu lateral', 'Início'] },
  { id: 'communities', label: 'Comunidades', icon: 'users', group: 'community', desc: 'Grupos temáticos moderados.', surfaces: ['Menu lateral', 'Início'] },
  { id: 'messages', label: 'Mensagens', icon: 'chat', group: 'community', desc: 'Conversas diretas e inquéritos.', surfaces: ['Menu lateral'] },
  { id: 'notifications', label: 'Notificações', icon: 'inbox', group: 'community', desc: 'Caixa de notificações.', surfaces: ['Menu lateral', 'Topo'] },
  { id: 'reels', label: 'Reels & lives', icon: 'eye', group: 'community', desc: 'Vídeos moderados e transmissões ao vivo.', surfaces: ['Menu lateral', 'Explorar'] },
  { id: 'explore', label: 'Explorar', icon: 'grid', group: 'discovery', desc: 'Hub de descoberta.', surfaces: ['Menu lateral'] },
  { id: 'strains', label: 'Variedades', icon: 'leaf', group: 'discovery', desc: 'Biblioteca educativa de variedades.', surfaces: ['Menu lateral', 'Início', 'Busca'] },
  { id: 'associations', label: 'Associações', icon: 'building', group: 'discovery', desc: 'Diretório de associações.', surfaces: ['Menu lateral', 'Atalhos'] },
  { id: 'marketplace', label: 'Marketplace', icon: 'bag', group: 'discovery', desc: 'Catálogo verificado com laudo.', surfaces: ['Menu lateral', 'Explorar'] },
  { id: 'ia', label: 'Assistente IA', icon: 'sparkles', group: 'tools', desc: 'Aguardando fontes, governança e provedor próprio.', surfaces: [], defaultOff: true, available: false },
  { id: 'donations', label: 'Fundo solidário', icon: 'heart', group: 'tools', desc: 'Campanhas e prestação de contas.', surfaces: ['Menu lateral', 'Atalhos'] },
  { id: 'commercial_payments', label: 'Pagamentos comerciais', icon: 'money', group: 'environment', desc: 'Checkout de pedidos e contribuições.', surfaces: [], defaultOff: true },
  { id: 'roleSwitcher', label: 'Alternador de visão', icon: 'toggle', group: 'environment', desc: 'Ver como outro papel (dev).', surfaces: ['Sidebar'], defaultOff: true },
  { id: 'maintenance', label: 'Modo manutenção', icon: 'ban', group: 'environment', desc: 'Takeover de manutenção.', surfaces: ['Global'], defaultOff: true },
];

export const FEATURES_BY_ID: Record<FeatureId, FeatureMeta> = Object.fromEntries(
  FEATURES_REGISTRY.map((f) => [f.id, f]),
) as Record<FeatureId, FeatureMeta>;
